/** The parts of Excel's worksheet-changed event the status reads. */
export interface SheetChange {
  worksheetId: string;
  /**
   * Who made the change, from ExcelApi 1.14. Older hosts leave it out, and every change then counts,
   * this add-in's own writes included.
   */
  triggerSource?: string;
}

/**
 * Whether a passing "Check for errors" still describes its sheet. The pass is for what the sheet read
 * when the check began, so any later change to that sheet by anyone but this add-in makes it stale:
 * the user, a co-author or another add-in.
 */
export class JournalCheckStatus {
  private checking: { worksheetId: string; changed: boolean } | null = null;
  private shownPass: string | null = null;

  /** A check begins reading the sheet. */
  reading(worksheetId: string): void {
    this.checking = { worksheetId, changed: false };
  }

  /** Ends the check of the sheet: whether the sheet changed while it ran, which makes its pass stale already. */
  changedWhileChecking(worksheetId: string): boolean {
    const changed = this.checking?.worksheetId === worksheetId && this.checking.changed;
    this.checking = null;
    return changed;
  }

  /** The status line shows the sheet's pass. */
  showingPass(worksheetId: string): void {
    this.shownPass = worksheetId;
  }

  /** The status line shows something else. */
  cleared(): void {
    this.shownPass = null;
  }

  /** A change in the workbook; true when it makes the pass the status line shows stale. */
  changed(change: SheetChange): boolean {
    if (change.triggerSource === 'ThisLocalAddin') return false;
    if (this.checking?.worksheetId === change.worksheetId) this.checking.changed = true;
    if (this.shownPass !== change.worksheetId) return false;
    this.shownPass = null;
    return true;
  }
}
